"use client";

import Image from "next/image";

export function ExperienceSection({ lookUpCMSData, homeDetails }: any) {
  return (
    <section id="experiences" className="py-10 md:py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {lookUpCMSData?.["Home - Section 3 : Your Journey, Your Way"] ? (
          <div
            dangerouslySetInnerHTML={{
              __html:
                lookUpCMSData?.["Home - Section 3 : Your Journey, Your Way"]
                  ?.Template,
            }}
          />
        ) : (
          <div className="text-center mb-20">
            <p className="text-[#B42025] tracking-[0.3em] mb-4 text-sm uppercase">
              Your Journey, Your Way
            </p>
            <h2 className="text-4xl md:text-6xl mb-6 text-[#1A1A1A]">
              Designed Around Your Journey
            </h2>
            <p className="text-gray-600 text-xl max-w-3xl mx-auto">
              Every journey is different. That's why Kavish creates experiences
              tailored to the way you travel.
            </p>
          </div>
        )}

        <div className="space-y-20">
          {homeDetails?.Experience?.map((experience: any, index: number) => (
            <div
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center ${
                index % 2 === 1 ? "lg:flex-row-reverse" : ""
              }`}
            >
              <div className={`${index % 2 === 1 ? "lg:order-2" : ""}`}>
                <div className="relative aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl group">
                  <Image
                    src={experience?.Image}
                    alt={experience?.Title}
                    className="object-cover group-hover:scale-105 transition-transform duration-700"
                    fill
                    sizes="(max-width: 1024px) 100vw, 50vw"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </div>
              </div>

              <div className={`${index % 2 === 1 ? "lg:order-1" : ""}`}>
                {/* <div className="inline-block px-4 py-2 bg-[#B42025]/10 text-[#B42025] rounded-full text-sm tracking-wider mb-6">
                  EXPERIENCE {String(index + 1).padStart(2, "0")}
                </div> */}
                <h3 className="text-xl md:text-3xl mb-6 text-[#1A1A1A]">
                  {experience?.Title}
                </h3>
                <div
                  suppressHydrationWarning={true}
                  className="text-gray-600 mb-6 leading-relaxed"
                  dangerouslySetInnerHTML={{
                    __html: experience?.Description?.trim(),
                  }}
                />
                {/* <Button
                  className="bg-[#B42025] hover:bg-[#8F1A1E] text-white group"
                  size="lg"
                >
                  Explore This Journey
                  <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                </Button> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
